import type { ExtendedMenuItem, OrderItemWithDetails } from '@/types/order'

interface NewOrderModalPublicApiOptions {
  selectItem: (menuItem: ExtendedMenuItem) => void
  addItemWithDetails: () => void
  increaseQuantity: (item: OrderItemWithDetails) => void
  decreaseQuantity: (item: OrderItemWithDetails) => void
  getItemQuantity: (menuItemId: number | string, variantId?: number | string | null) => number
  createOrder: () => Promise<void>
  calculateItemTotal: (item: OrderItemWithDetails) => string
}

export function useNewOrderModalPublicApi(options: NewOrderModalPublicApiOptions) {
  return {
    selectItem: options.selectItem,
    addItemWithDetails: options.addItemWithDetails,
    increaseQuantity: options.increaseQuantity,
    decreaseQuantity: options.decreaseQuantity,
    getItemQuantity: options.getItemQuantity,
    createOrder: options.createOrder,
    calculateItemTotal: options.calculateItemTotal
  }
}
